import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function FadeUp({ children, delay = 0, y = 32, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function MaskLine({ children, delay = 0, className = "", onView = false }) {
    const animProps = onView
        ? {
              whileInView: { y: "0%" },
              viewport: { once: true, amount: 0.4 },
          }
        : { animate: { y: "0%" } };
    return (
        <span
            className={`block overflow-hidden pb-[0.1em] ${className}`}
            style={{ marginBottom: "-0.1em" }}
        >
            <motion.span
                className="block will-change-transform"
                initial={{ y: "112%" }}
                transition={{ duration: 1, delay, ease: EASE }}
                {...animProps}
            >
                {children}
            </motion.span>
        </span>
    );
}
